import React, { Fragment } from 'react';

import { Box, Divider } from '@mui/material';
import PropTypes from 'prop-types';

import IconGroup from '../IconGroup';

import { iconGroupPanelItemStyles, iconGroupPanelWrapperStyles } from './IconGroupPanel.styles';

const IconGroupPanel = ({ groups }) => (
  <Box sx={iconGroupPanelWrapperStyles}>
    {groups.map(({ id, label, rows }, index) => (
      <Fragment key={id}>
        {!!index && <Divider flexItem orientation="vertical" />}
        <Box sx={iconGroupPanelItemStyles}>
          <IconGroup label={label} rows={rows} />
        </Box>
      </Fragment>
    ))}
  </Box>
);

IconGroupPanel.propTypes = {
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      rows: PropTypes.array.isRequired,
    }),
  ).isRequired,
};

export default IconGroupPanel;
